import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import Grid from "@material-ui/core/Grid";
import CloseIcon from "@material-ui/icons/Close";
import LungChart from "../Chart/LungChart";
import PrintButton from "../PrintButton";
import { prostateRiskCaculation } from "../../../../utils/calculate";

const useStyles = makeStyles((theme) => ({
  title: {
    fontSize: 22,
    fontWeight: 600,
    paddingTop: 12,
    paddingBottom: 12,
  },
  close: {
    cursor: "pointer",
  },
  contents: {
    padding: "16px 24px",
  },
  resultSub: {
    marginTop: 4,
    marginBottom: 44,
    color: theme.palette.primary.main,
    "& h3": {
      margin: 0,
    },
  },
  resultDetail: {
    marginBottom: theme.spacing(4.5),
    "& h6": {
      marginBottom: theme.spacing(1),
    },
    "& .blue": {
      color: "#115bab",
      fontWeight: 700,
      fontSize: 20,
    },
    "& .black": {
      color: "#333333",
      fontWeight: 700,
      fontSize: 20,
    },
    "& .blackSub": {
      color: "#333333",
      fontWeight: 700,
      fontSize: 20,
    },
  },
  result1: {
    height: 250,
    marginTop: 12,
    marginBottom: 12,
    border: "1px solid rgb(0 0 0 / 26%)",
  },
  result1Title: {
    width: 150,
    textAlign: "center",
    borderRight: "1px solid rgb(0 0 0 / 26%)",
    height: "100%",
    fontSize: 20,
  },
  result1Total: {
    flex: 1,
    fontWeight: 500,
    fontSize: 20,
  },
  resultSub1: {
    color: theme.palette.primary.main,
  },
  coment: {
    color: "#747474",
    marginTop: 12,
    marginBottom: 18,
  },
  grapY: {
    fontSize: 14,
    color: "#333333",
    paddingLeft: 8,
  },
  grapTitle: {
    fontSize: 16,
    fontWeight: 600,
    marginBottom: 12,
  },
  numberResult: {
    borderRight: "1px solid rgb(0 0 0 / 26%)",
    width: "50%",
    height: "100%",
  },
  numberResult2: {
    flex: 1,
    width: "50%",
    height: "100%",
  },
  numberResultTitle: {
    color: "#747474",
    height: 60,
    background: "#f2f2f2",
    fontSize: 18,
  },
  totalCon: {
    height: 150,
    fontSize: 24,
  },
  leftContents: {
    width: 300,
  },
  rightContents: {
    width: 492,
  },
  leftTitle: {
    width: "50%",
    color: "#115bab",
    marginTop: 4,
    fontWeight: 700,
    marginBottom: 10,
    "& h3": {
      margin: 0,
    },
    "& .subtitle": {
      color: "#333333",
      fontWeight: 400,
      paddingTop: 12,
      fontSize: 14,
    },
  },
  rightTitle: {
    width: "50%",
    marginTop: 4,
    fontSize: 10,
    color: "#747474",
  },
  chart: {
    width: 492,
    height: 220,
  },
  detail: {
    fontSize: 20,
    fontWeight: 400,
    lineHeight: 1.5,
  },
  table: {
    border: "1px solid #c9d9ea",
  },
  title1: {
    width: "50%",
    fontSize: 20,
    paddingTop: 15,
    paddingBottom: 15,
    color: "#60768e",
    fontWeight: 400,
    borderBottom: "1px solid  #c9d9ea",
    borderRight: "1px solid  #c9d9ea",
    height: 57,
  },
  title2: {
    width: "50%",
    paddingTop: 15,
    paddingBottom: 15,
    fontSize: 20,
    color: "#60768e",
    fontWeight: 400,
    borderBottom: "1px solid  #c9d9ea",
    height: 57,
  },
  contents1: {
    width: "50%",
    fontSize: 20,
    paddingTop: 15,
    paddingBottom: 15,
    color: "#60768e",
    fontWeight: 400,
    borderRight: "1px solid  #c9d9ea",
  },
  contents2: {
    width: "50%",
    fontSize: 20,
    paddingTop: 15,
    paddingBottom: 15,
    color: "#60768e",
    fontWeight: 400,
    "& .black": {
      color: "#333333",
      // fontWeight: 600,
    },
  },
  contents3: {
    width: "50%",
    fontSize: 20,
    paddingTop: 15,
    paddingBottom: 15,
    color: "#60768e",
    fontWeight: 400,
  },
  contents4: {
    width: "50%",
    fontSize: 20,
    paddingTop: 15,
    paddingBottom: 15,
    color: "#60768e",
    fontWeight: 400,
    "& .black": {
      color: "#333333",
    },
    borderLeft: "1px solid  #c9d9ea",
  },
  contentsStyle: {
    paddingLeft: 36,
    paddingRight: 36,
    paddingTop: 11,
    paddingBottom: 11,
    "& .right": {
      width: 130,
    },
    "& .black": {
      color: "#333333",
    },
  },
  contentsStyle2: {
    paddingLeft: 36,
    width: 400,
    justifyContent: "center",
    paddingRight: 36,
    paddingTop: 11,
    paddingBottom: 11,
    "& .right": {
      width: 130,
    },
    "& .black": {
      color: "#333333",
    },
  },
  footer: {
    paddingTop: theme.spacing(2.5),
    paddingBottom: theme.spacing(2.5),
    paddingLeft: theme.spacing(2.5),
    paddingRight: theme.spacing(2.5),
    maxHeight: 90,
    overflow: "hidden",
  },
  footerButton: {
    fontSize: 16,
    fontWeight: 400,
  },
  black: {
    color: "#333333",
    fontSize: 20,
    fontWeight: 600,
  },
  blackSub: {
    fontSize: 20,
    fontWeight: 400,
  },
  blue: {
    color: "#115bab",
  },
  tip: {
    color: "#747474",
    fontSize: 14,
    paddingTop: 12,
    paddingBottom: 12,
  },
}));
const data = [
  {
    name: "0~4세",
    남성: 0,
    여성: 0,
  },
  {
    name: "5~9세",
    남성: 0,
    여성: 0,
  },
  {
    name: "10~14세",
    남성: 0,
    여성: 0,
  },
  {
    name: "15~19세",
    남성: 0,
    여성: 0,
  },
  {
    name: "20~24세",
    남성: 0.1,
    여성: 0,
  },
  {
    name: "25~29세",
    남성: 0.1,
    여성: 0,
  },
  {
    name: "30~34세",
    남성: 0,
    여성: 0,
  },
  {
    name: "35~39세",
    남성: 0.3,
    여성: 0,
  },
  {
    name: "40~44세",
    남성: 0.8,
    여성: 0,
  },
  {
    name: "45~49세",
    남성: 3.1,
    여성: 0,
  },
  {
    name: "50~54세",
    남성: 14.2,
    여성: 0,
  },
  {
    name: "55~59세",
    남성: 47.6,
    여성: 0,
  },
  {
    name: "60~64세",
    남성: 124.2,
    여성: 0,
  },
  {
    name: "65~69세",
    남성: 247.2,
    여성: 0,
  },
  {
    name: "70~74세",
    남성: 398.1,
    여성: 0,
  },
  {
    name: "75~79세",
    남성: 460.4,
    여성: 0,
  },
  {
    name: "80~84세",
    남성: 440.4,
    여성: 0,
  },
  {
    name: "85세이상",
    남성: 373.1,
    여성: 0,
  },
];
// const ye = ["y1", "y2", "y3", "y4", "y5"];
const ProstateReportForm = ({
  total,
  que1,
  que2,
  que3,
  que4,
  sex,
  cm,
  kg,
  age,
  handleClose,
  onReportGo,
  hpyn,
  pa,
  setHpyn,
  setHa,
}) => {
  const classes = useStyles();
  const fiveTotal = prostateRiskCaculation(total);
  const ageChecker = (age, sex = true) => {
    let title = "";
    if (0 <= age && age < 5) {
      title = data[0];
    } else if (5 <= age && age < 10) {
      title = data[1];
    } else if (10 <= age && age < 15) {
      title = data[2];
    } else if (15 <= age && age < 20) {
      title = data[3];
    } else if (20 <= age && age < 25) {
      title = data[4];
    } else if (25 <= age && age < 30) {
      title = data[5];
    } else if (30 <= age && age < 35) {
      title = data[6];
    } else if (35 <= age && age < 40) {
      title = data[7];
    } else if (40 <= age && age < 45) {
      title = data[8];
    } else if (45 <= age && age < 50) {
      title = data[9];
    } else if (50 <= age && age < 55) {
      title = data[10];
    } else if (55 <= age && age < 60) {
      title = data[11];
    } else if (60 <= age && age < 65) {
      title = data[12];
    } else if (70 <= age && age < 70) {
      title = data[13];
    } else if (75 <= age && age < 75) {
      title = data[14];
    } else if (75 <= age && age < 80) {
      title = data[15];
    } else if (80 <= age && age < 85) {
      title = data[16];
    } else {
      title = data[17];
    }
    if (sex) {
      return title.남성;
    } else {
      return title.여성;
    }
  };
  return (
    <>
      <DialogTitle id="responsive-dialog-title">
        <Grid container alignItems="center" justify="space-between">
          <Grid className={classes.title}>
            전립선암 위험도 자가진단 결과 레포트
          </Grid>
          <Grid className={classes.close} onClick={handleClose}>
            <CloseIcon style={{ fontSize: 24, color: "#969696" }} />
          </Grid>
        </Grid>
      </DialogTitle>
      <Grid
        container
        justify="center"
        direction="column"
        className={classes.contents}
      >
        <Grid container justify="center" direction="column">
          <Grid container direction="column">
            <h3 className={classes.blue}>입력정보</h3>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              direction="row"
              className={classes.table}
            >
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.title1}
                >
                  기본정보
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.title2}
                >
                  생활정보
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  direction="column"
                  className={classes.contents1}
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>성별</Grid>
                      <Grid>
                        <span className="black">{sex ? "남성" : "여성"}</span>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>신장</Grid>
                      <Grid>
                        <span className="black">{cm.value} cm</span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>연령</Grid>
                      <Grid>
                        <span className="black">{age.value}세</span>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>체중</Grid>
                      <Grid>
                        <span className="black">&nbsp;{kg.value} kg</span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.contents2}
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>당뇨</Grid>
                      <Grid>
                        <span className="black">
                          &nbsp;{que1 ? "있음" : "없음"}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>고혈압</Grid>
                      <Grid>
                        <span className="black">
                          &nbsp;{hpyn ? "있음" : "없음"}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle}
                  >
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>갑력(흡연)</Grid>
                      <Grid>
                        <span className="black">
                          &nbsp;{que4 ? "있음" : "없음"}
                        </span>
                      </Grid>
                    </Grid>
                    <Grid
                      container
                      direction="row"
                      justify="space-between"
                      className="right"
                    >
                      <Grid>운동여부</Grid>
                      <Grid>
                        <span className="black">
                          &nbsp;{pa ? "있음" : "없음"}
                        </span>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid container style={{ marginTop: 10 }}>
            <h3 className={classes.blue}>절대 위험도</h3>
            <Grid
              container
              justify="space-between"
              alignItems="center"
              direction="row"
              className={classes.table}
            >
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.title1}
                >
                  종합점수
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.title2}
                >
                  <span className={classes.black}>
                    {total}
                    <span className={classes.blackSub}> / 122 점</span>
                  </span>
                </Grid>
              </Grid>
              <Grid
                container
                alignItems="center"
                justify="center"
                direction="row"
              >
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.contents3}
                >
                  5년 위험도
                </Grid>
                <Grid
                  container
                  alignItems="center"
                  justify="center"
                  className={classes.contents4}
                >
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle2}
                  >
                    <Grid>
                      1년차 생존률 :&nbsp;
                      <span className="black">{fiveTotal.y1}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle2}
                  >
                    <Grid>
                      2년차 생존률 :&nbsp;
                      <span className="black">{fiveTotal.y2}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle2}
                  >
                    <Grid>
                      3년차 생존률 :&nbsp;
                      <span className="black">{fiveTotal.y3}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle2}
                  >
                    <Grid>
                      4년차 생존률 :&nbsp;
                      <span className="black">{fiveTotal.y4}%</span>
                    </Grid>
                  </Grid>
                  <Grid
                    container
                    alignItems="center"
                    justify="space-between"
                    direction="row"
                    className={classes.contentsStyle2}
                  >
                    <Grid>
                      5년차 생존률 :&nbsp;
                      <span className="black">{fiveTotal.y5}%</span>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          </Grid>
          <Grid className={classes.tip}>
            * 점수가 높을수록 고위험군 입니다.
          </Grid>
          <Grid container direction="column">
            <h3 className={classes.blue}>상대 위험도</h3>
            <div style={{ paddingBottom: 11, paddingLeft: 1 }}>
              발생빈도(건수)
            </div>
            <Grid style={{ width: "100%", height: "250px" }}>
              <LungChart age={age} />
            </Grid>
          </Grid>
          <Grid className={classes.tip}>
            * 출처 : KOSIS 보건복지부 암등록 통계 2020년
          </Grid>
          <Grid container direction="column">
            <h3 className={classes.blue}>결과진단</h3>
            <Grid className={classes.detail}>
              {/* 전립선암은 2017년 전체 암 발생의 11.6%로 매우 흔한 암이었습니다.
              <br />
              초기에는 증상이 없을 수도 있으나, 발견된 후 사망률이 높습니다. */}
              {/* <br /> */}
              환자분의 1년이내 생존률은&nbsp;
              <span className={classes.blue} style={{ fontWeight: 600 }}>
                {fiveTotal.y1}%
              </span>
              입니다.
              <br /> 같은 성별, 연령대의 평균 전립선암 발생빈도는 10만 명
              당&nbsp;
              {ageChecker(age.value, sex)}명입니다.
              <br /> 전립선암 조기 검사의 이득과 손해를 알아보시고 현명한 결정
              하시길 추천합니다.
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <DialogActions>
        <Grid
          container
          justify="center"
          alignItems="center"
          className={classes.footer}
        >
          <PrintButton
            total={total}
            name={"출력"}
            sex={sex}
            age={age}
            que1={que1}
            que2={que2}
            que3={que3}
            que4={que4}
            cm={cm}
            kg={kg}
            fiveTotal={fiveTotal}
            perage={ageChecker(age.value, sex)}
            hpyn={hpyn}
            pa={pa}
          />
        </Grid>
      </DialogActions>
    </>
  );
};

export default ProstateReportForm;
